<template>
  <div class="sjbz">
    <div class="banners">
      <div class="banner-title">
        <div class="t1">AI数字人手语</div>
        <div class="t2">基于数字技术的手语翻译平台</div>
      </div>
      <video
        src="../assets/img/banner1.mp4"
        autoplay
        loop
        muted
        style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0;"
      />
    </div>
    <div class="content-cr">
      <div
        style="display: flex; justify-content: space-between;margin-top: 60px;"
      >
        <img
          style="width: 600px;object-fit: contain;"
          src="../assets/img/syr/tp1.png"
          alt=""
        />
        <div style="margin-left: 40px;">
          <div
            style="font-size: 32px;margin-bottom: 50px;list-style: 60px;color:#333"
          >
            AI手语翻译
          </div>
          <div style="font-size: 24px;line-height: 48px;color:#666">
            是一种基于大数据和AI实时手语翻译平台，在为听障人群提供协助与外界沟通的平台。采用了人工智能自然语言处理的概率算法和神经网络技术，以平台即服务（PaaS）模式为基础，结合手语数据库和多模态深度学习技术，实现语音与手语的快速转换能力。通过增量数据采集和增量学习，不断优化系统翻译能力，提升产品性能和用户体验，为用户提供快速、有效的手语沟通。
          </div>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-between;margin-top: 60px;"
      >
        <div style="margin-right: 40px;">
          <div style="font-size: 24px;line-height: 48px;color:#666">
            涵盖GF0020—2018中国通用手语常用词表GF0021—2019
            汉语手指字母方案所包含的所有词汇。
          </div>
        </div>
        <img
          style="width: 600px;object-fit: contain;"
          src="../assets/img/syr/tp2.png"
          alt=""
        />
        <img
          style="width: 260px;object-fit: contain;"
          src="../assets/img/syr/tp3.png"
          alt=""
        />
      </div>
    </div>
    <div class="content-1" style="margin-top: 40px;">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">核心技术</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
      </div>
      <div style="font-size: 24px;text-align: center;margin-top: 20px;">
        手语翻译 手语合成
      </div>
      <div style="width: 1400px; margin: 0 auto">
        <img
          style="width: 100%;margin: 40px 0;"
          src="../assets/img/syr/tp4.png"
          alt=""
        />
      </div>
    </div>
    <div class="content-1" style="margin-top: 40px;">
      <!-- <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">核心技术</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <div class="ly-1">
          <div class="ly-1-1">
            <div class="card1" v-for="(item, index) in cardList" :key="index">
              <div class="num1">痛点{{ index + 1 }}</div>
              <div class="title1">{{ item.title }}</div>
              <div class="content1" style="white-space: pre-line;">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
        <div class="content-1">
    </div> -->
      <div class="content-1-1" style="margin-top: 40px;">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">服务模式</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
      </div>
      <div style="width: 1400px; margin: 0 auto">
        <img
          style="width: 100%;margin: 40px 0;"
          src="../assets/img/syr/tp5.png"
          alt=""
        />
      </div>
      <!-- 流程 -->

      <!-- 应用场景 -->
      <div class="content-1-1" style="margin-top: 40px;">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">公共服务领域解决方案</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
      </div>
      <div style="width: 1400px; margin: 0 auto">
        <div style="font-size: 28px;text-align: center;margin: 30px 0;">
          1、医疗行业
        </div>
        <div class="flexs">
          <div class="flexs-left">
            <img src="../assets/img/syr/tp6.png" alt="" />
            <div class="left-t1">
              在医院固定场所（如导医台、护士站等）部署双屏翻译官，同时配备租用便携款，满足多种需求。
            </div>
          </div>
          <div class="flexs-right">
            <div style="display: flex;">
              <img src="../assets/img/syr/tp7.png" alt="" />
              <div>
                <div class="right-t1">
                  在预约挂号界面提供<span style="color:#7caefb"
                    >文字转手语功能</span
                  >
                </div>
                <div class="right-t1">
                  手语数字人和功能界面可以根据需求<span style="color:#7caefb"
                    >定制</span
                  >
                </div>
              </div>
            </div>
            <div style="display: flex;margin-top: 40px;">
              <div>
                <div class="right-t2">扫码可得</div>
                <div class="right-t2">1.H5页面/视频（手语+语音+大字）</div>
                <div class="right-t2">2.PDF文档</div>
              </div>
              <img src="../assets/img/syr/tp8.png" alt="" />
            </div>
          </div>
        </div>
        <div class="flexs">
          <div style="width: 50%;">
            <div style="font-size: 28px;text-align: center;margin: 30px 0;">
              2、交通行业
            </div>
            <img style="width: 100%;" src="../assets/img/syr/tp9.png" alt="" />
          </div>
          <div style="width: 50%;">
            <div style="font-size: 28px;text-align: center;margin: 30px 0;">
              3、一键报警
            </div>
            <img style="width: 100%;" src="../assets/img/syr/tp10.png" alt="" />
          </div>
        </div>
        <div style="font-size: 28px;text-align: center;margin: 30px 0;">4、文旅行业</div>
        <img style="width: 100%;" src="../assets/img/syr/tp11.png" alt="" />
        <div style="font-size: 28px;text-align: center;margin: 30px 0;">5、教育行业</div>
        <div class="ly-2">
            <div class="ly-2-left">
              <img style="width: 100%;" src="../assets/img/syr/tp12.png" alt="" />
            </div>
            <div class="ly-2-right">
              <div class="ly-2-right-2">痛点</div>
              <div class="ly-2-right-1">教学资源不足</div>
              <div class="ly-2-right-1">课程内容难度大</div>
              <div class="ly-2-right-1">难以与教师沟通</div>
              <div class="ly-2-right-1">缺乏辅助设备</div>
              <div class="ly-2-right-2" style="margin-top: 100px;">功能概述</div>
              <div class="ly-2-right-1">文字划词</div>
              <div class="ly-2-right-1">文字转手语功能</div>
              <div class="ly-2-right-1">英语转手语功能</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Banner from "../components/Banner";
export default {
  metaInfo: {
    title: "中启联信_AI数字人手语",
    meta: [
      { name: "keywords", content: "中启联信、AI赋能、AI数字人、AI手语翻译、手语转译、AI解决方案、AI低空经济" },
      { name: "description", content: "中启联信、AI赋能、AI数字人、AI手语翻译、手语转译、AI解决方案、AI低空经济" },
    ],
  },
  data() {
    return {
      cardList: [
        {
          title: "火情发现晚",
          content:
            "早期初发林下火识别难度大\n无人机续航能力低\n人工巡林效率低下",
        },
        {
          title: "识别能力差",
          content: "干扰因素多\n系统误报高\n无人机不具备自主识别能力",
        },
        {
          title: "值守/巡护难",
          content:
            "林场值守人员配备少、年龄偏大\n护林员信息化水平不高，办公效率低",
        },
        {
          title: "协同联动弱",
          content: "各传感器间存在数据壁垒\n多套系统并行，融合联动弱",
        },
      ],
      hovercjIndex: null,
      hoverIndex: 0,
      tabPosition: "left",
      activeName: "first",
      cjList: [
        {
          title: "内容审核场景",
          content:
            "通过专业的标注实现对问答评论、昵称签名、日记帖子、 恶意推广、图文图集、音视频弹幕中的内容合规合法性进行识别。",
        },
        {
          title: "智能安防",
          content:
            "核心能力包括人脸打点、骨骼关键点、人体拉框、视频切分、目标跟踪、语义分割等标注类型，支持平安城市、车辆人流监测人脸识别等场景数据标注。",
        },
        {
          title: "智能金融",
          content:
            "核心能力包括车辆保险鉴定、人物对话转写、命名实体识别、票据文字识别(OCR)、人脸标注、风控数据标注等标注类型，支持身份认证、智能风控、智慧柜台等场景数据标注。",
        },
        {
          title: "智能驾驶",
          content:
            "核心能力包括图片通用拉框、车道线、DMS、3D点云、2D/3D融合、全景语义分割等标注类型，支持自动驾驶、智能驾舱、自动泊车等场景数据标注。",
        },
        {
          title: "智能家居",
          content:
            "核心能力包括人物语音转写、行为意图、声纹识别、领域识别、语句泛化、语义分割等标注类型，支持智能音箱、智能电视、智能扫地机器人等场景数据标注。",
        },
        {
          title: "新零售",
          content:
            "核心能力包括商品分类识别、票据识别转写、服饰拉框、商品属性、人脸表情、目标跟踪等标注类型，支持智慧门店、无人货柜、虚拟试衣等场景数据标注。",
        },
      ],
      ysLIst: [
        {
          img: require("../assets/img/zq/caiji-youshi-1-0.png"),
          title: "数据安全专业的团队",
          content:
            "在全国自建多个数据中心，有众多稳定的外包合作供应商，包括众包资源。专属项目经理全程多维度管控，确保数据交付质量。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-1.png"),
          title: "数据标注的全面覆盖",
          content:
            "包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-2.png"),
          title: "定制化数据采集流程",
          content:
            "拥有庞大的众包团队和各领域合作伙伴，支持全球数据采集需求，针对细分AI应用场景进行数据定制。数据采集支持大规模数据采集及数据清理、质量检测、预识别等，保证项目交付的质量和效率。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-3.png"),
          title: "成品数据集的多样性和实用性",
          content:
            "提供200+成品数据集，包括ASR、文本、发音词典、图像及视频，为快速部署提供高质量数据支持。",
        },
      ],
      sjList: [
        {
          title: "数据治理",
          content:
            "确定数据标准;\n数据清洗;\n数据管理能力评估;\n数据资源目录梳理;\n……",
        },
        {
          title: "数据确权",
          content:
            "了解数据登记情况;\n界定数据来源、持有加工、流通、使用过程中的合法权利;\n明确权利或权利组合;\n获取相关权证材料;\n……",
        },
        {
          title: "数据入表专业咨询",
          content:
            "数据资产确认条件;\n基于场景的预期收益合理性判断;\n资产分类的合理性和确定依据分析;\n后续计量的价值影响分析;\n……",
        },
        {
          title: "数据资产质量评价",
          content:
            "明确数据质量评价对象及范围;\n建立质量要素评价指标体系;\n执行数据质量评价程序;\n撰写数据质量评价报告;\n……",
        },
        {
          title: "数据资产价值评估",
          content:
            "明确评估对象和范围明确应用场景和资产类型;\n数据资产评估方法适用性分析;\n数据资产价值评估;\n出具价值评估报告;\n……",
        },
      ],
      itemList: [
        {
          bg: require(`@/assets/img/advantage-0.png`),
          title: "上千次项目打磨",
        },
        {
          bg: require(`@/assets/img/advantage-1.png`),
          title: "100%项目交付质量",
        },
        {
          bg: require(`@/assets/img/advantage-2.png`),
          title: "量身打造定制化方案",
        },
        { bg: require(`@/assets/img/advantage-3.png`), title: "50+技术软著" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sjbz {
  width: 100%;
  .flexs {
    display: flex;
    justify-content: space-between;
    .flexs-left {
      width: 56%;
      .left-t1 {
        font-size: 24px;
        width: 600px;
        margin-left: 100px;
      }
    }
    .flexs-right {
      width: 40%;
      .right-t1 {
        margin-top: 40px;
        margin-left: -100px;
        font-size: 24px;
      }
      .right-t2 {
        margin-top: 20px;
        font-size: 24px;
      }
    }
  }
  .content-3 {
    margin-top: 80px;
    .content-3-1 {
      text-align: center;
    }
    .content-3-2 {
      width: 1400px;
      margin: 68px auto;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 288px;
        height: 274px;
        background: #3a4354;
        border-radius: 6px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .box1-1 {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 45px;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          line-height: 24px;
        }
        .box1-2 {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          color: #fff;
          text-align: center;
          opacity: 0;
          -webkit-animation: advantageHide 1s;
          animation: advantageHide 1s;
          @keyframes advantageHide {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .content-2 {
    background: #f9fbff;
    width: 100%;
    padding-top: 60px;
    min-width: 1200px;
    .content-2-3 {
      // width: 1200px;
      margin: 20px auto;
      ::v-deep .el-tabs__nav-scroll {
        width: 10%;
        margin: 0 auto;
      }
      .content-2-3-1 {
        width: 100%;
        min-width: 1200px;
        height: 23.43vw;
        background: #2b3953;
        position: relative;
        margin-top: 4.9vw;
        .text1 {
          text-align: left;
          color: #fff;
          width: 62.5vw;
          margin: 0 auto;
          padding-top: 5.28vw;
        }
        .img1 {
          opacity: 1;
          width: 50vw;
          height: 26.84vw;
          position: absolute;
          right: 0;
          bottom: 0;
          transition: all 0.5s ease-in 0.5s;
          animation: fadeIn 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        .img2 {
          width: 30.15vw;
          height: 15.98vw;
          position: absolute;
          right: 30.57vw;
          bottom: 0;
          animation: slide-in-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            forwards;
          @keyframes slide-in-bottom {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .content-2-1 {
      text-align: center;
    }
    .content-2-2 {
      margin: 32px auto;
      text-align: center;
      .tabs {
        margin: 0 auto;

        ::v-deep .el-radio-button__inner {
          width: 400px;
          height: 48px;
          line-height: 24px;
          font-size: 20px;
        }
      }
    }
  }
  .content-1 {
    background: #fff;
    width: 100%;
    min-width: 1400px;
    .ly-2 {
      width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .ly-2-left {
        margin: 40px 0;
        width: 70%;
      }
      .ly-2-right {
        margin: 40px 0;
        width: 20%;
        .ly-2-right-1 {
          font-size: 28px;
          position: relative;
          text-align: left;
          padding-left: 30px;
          margin: 30px 0;
          // line-height: 100px;
          &::before {
            content: "";
            position: absolute;
            width: 20px;
            height: 20px;
            background: #526aff;
            border-radius: 50%;
            left: 0px;
            top: 15px;
          }
        }
        .ly-2-right-2 {
          width: 200px;
          height: 50px;
          line-height: 50px;
          background: #7caefb;
          color: #fff;
          font-size: 32px;
          text-align: center;
          margin: 20px 0;
          border-radius: 25px;
        }
      }
    }
    .ly-1 {
      display: flex;
      justify-content: space-between;
      .ly-1-1 {
        padding: 30px;
        width: 1400px;
        margin: 32px auto;
        // text-align: center;
        display: flex;
        justify-content: space-between;
        .card1 {
          width: 280px;
          height: 240px;
          background: transparent;
          border-radius: 4px;
          border: 1px solid #dce2ef;
          text-align: center;
          padding: 30px;
          .num1 {
            width: 120px;
            height: 60px;
            background: #7caefb;
            color: #fff;
            font-size: 32px;
            line-height: 60px;
            text-align: center;
            margin: 0px auto 30px;
          }
          .title1 {
            font-size: 24px;
            font-weight: bold;
            color: #000;
            margin-bottom: 20px;
          }
          .content1 {
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            color: #333;
          }
          &:hover {
            background: #fff;
            box-shadow: 4px 6px 20px 0 rgba(0, 0, 0, 0.06);
            border: 1px solid #dce2ef;
          }
        }
        .tabs {
          margin: 0 auto;

          ::v-deep .el-radio-button__inner {
            width: 400px;
            height: 48px;
            line-height: 24px;
            font-size: 20px;
          }
        }
      }
    }
    .content-1-1 {
      text-align: center;
      .title-top {
        display: flex;
        justify-content: center;
        align-items: center;
        .title1 {
          font-size: 36px;
          margin: 0px 20px;
        }
      }
      &:active {
        background: linear-gradient(135deg, #526aff, #7caefb) !important;
        color: #fff;
      }
    }
  }
  .content-cr {
    width: 1400px;
    margin: 0 auto;
  }
  .bz-4 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-4-card {
      width: 432px;
      height: 210px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-bottom: 20px;
      position: relative;
      .card-title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
      }
      .card-content {
        width: calc(100% - 80px);
        height: calc(100% - 80px);
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        padding: 40px;
      }
    }
  }
  .bz-3 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-3-1 {
      font-size: 32px;
      font-weight: bold;
      color: #7caefb;
    }
  }
  .bz-2 {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 38px;
    margin: 40px auto;
    .bz-2-card {
      .bz-2-card-1 {
        font-size: 24px;
        font-weight: bold;
        color: rgb(24, 24, 24);
        line-height: 25px;
        margin: 30px auto 16px;
      }
      .bz-2-card-2 {
        text-align: left;
        text-indent: 2em;
        font-size: 18px;
        font-weight: 400;
        color: rgb(112, 117, 127);
        line-height: 30px;
        width: 540px;
        margin: auto;
      }
      width: calc(50% - 40px);
      height: 330px;
      text-align: center;
      margin-bottom: 18px;
      margin-left: 11px;
      margin-right: 11px;
      background: transparent;
      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(220, 226, 239);
      border-image: initial;
      &:hover {
        box-shadow: rgba(0, 0, 0, 0.06) 4px 6px 20px 0px;
        background: rgb(255, 255, 255);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(220, 226, 239);
        border-image: initial;
      }
    }
  }
  .bz-1 {
    margin: 40px 0;
    width: 100%;
    min-width: 1400px;
    .bz-list {
      width: 1400px;
      display: flex;
      justify-content: space-between;
      margin: 0px auto;
      .img-1 {
        width: 516px;
        height: 326px;
      }
      .list-r {
        width: 592px;
        height: 345px;
        position: relative;
        .list-r-2 {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          .list-r-2-1 {
            width: 295px;
            margin-top: 10px;
            color: rgb(58, 67, 84);
            font-size: 24px;
            line-height: 60px;
            position: relative;
            text-align: left;
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              position: relative;
              top: -3px;
              margin-right: 10px;
              background: rgb(82, 106, 255);
              border-radius: 50%;
            }
          }
        }
        .list-r-1 {
          color: rgb(58, 67, 84);
          font-size: 28px;
          font-weight: 700;
          position: relative;
          display: flex;
          justify-content: space-between;
          z-index: 3 !important;
          &::before {
            content: "";
            position: absolute;
            left: -2px;
            top: 1px;
            display: block;
            width: 60px;
            height: 36px;
            z-index: -1 !important;
            background: linear-gradient(
              315deg,
              rgba(124, 174, 251, 0),
              rgb(82, 106, 255)
            );
            border-radius: 4px;
          }
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 42px;
          height: 12px;
          z-index: 1;
          background: linear-gradient(
            95deg,
            rgba(124, 174, 251, 0),
            rgb(82, 106, 255)
          );
          border-radius: 4px;
        }
      }
    }
  }
  .content-1-2 {
    display: flex;
    margin-top: 30px;
    .home-app-left {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
      .t1 {
        font-size: 20px;
        color: #fff;
        line-height: 60px;
        margin: 20px 0;
      }
    }
    .home-app-center {
      width: 900px;
      height: 247px;
      background-image: url(https://databaker-gw-static.oss-accelerate.aliyuncs.com/assets/images/newHome/app-bg.png);
      background-size: 100% 100%;
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 0 6px 6px 0;
      position: relative;
      text-align: center;
      font-size: 40px;
      padding-top: 220px;
    }
    .home-app-right {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
    }
  }
}
.home-achieve {
  position: relative;
  width: 1400px;
  margin: -60px auto;
  display: flex;
  z-index: 3;
  justify-content: space-between;
  .cards {
    transform: translateY(0px);
    opacity: 1;
    animation-delay: 200ms;
    width: 388px;
    height: 112px;
    background: #fff;
    box-shadow: 2px 6px 10px 0 rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    display: flex;
  }
}
.banners {
  width: 100%;
  height: 400px;
  position: relative;
  .banner-title {
    position: absolute;
    z-index: 3;
    width: 1400px;
    min-width: 1400px;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    .t1 {
      font-size: 2.2vw;
      font-family: Alibaba-PuHuiTi-Bold;
      color: #3a4354;
      font-weight: bold;
    }
    .t2 {
      font-size: 1.2vw;
      width: 567px;
      font-weight: 400;
      color: #3a4354;
      line-height: 40px;
      margin-top: 23px;
      font-family: Alibaba-PuHuiTi-Regular;
    }
  }
  video {
    height: 100%;
    width: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    // bottom: 0px;
    z-index: -1;
  }
}
</style>
